import { Accordion } from '@any-ui-react/core';
import classNames from 'classnames';

import { EllipseIcon } from '@anyx/shared-icons';
import { Card } from '@anyx/shared-ui';
import { DateUtils } from '@anyx/shared-utils';

import { NotificationWithReadState } from '../../types';
import { NotificationsUtils } from '../../utils';

interface NotificationCardProps {
  notification: NotificationWithReadState;
  handleOnRead: (notification: NotificationWithReadState) => void;
}

export const NotificationCard = ({ notification, handleOnRead }: NotificationCardProps) => {
  const { read, createdAt, languages } = notification;
  const formatDate = NotificationsUtils.getNotificationDate(createdAt);
  const { title, body } = NotificationsUtils.getNotificationLanguage(languages);
  return (
    <Card className="mb-4">
      <Accordion
        classNames={{
          label: 'p-0',
          item: 'border-0',
          content: 'p-0',
          control: 'p-0',
        }}
      >
        <Accordion.Item value={title}>
          <Accordion.Control
            variant="default"
            className="hover:bg-transparent"
            icon={
              <div className="mt-0 flex h-8">
                <EllipseIcon
                  className={classNames('fill-green-5 h-2 w-2 self-start', { invisible: !!read })}
                />
              </div>
            }
            onClick={() => {
              if (!read) {
                handleOnRead(notification);
              }
            }}
          >
            <h1 className={classNames({ 'font-bold': !read })}>{title}</h1>
            <p className="text-gray-6 mt-1 text-xs">
              {DateUtils.formatDateInTimeZone(formatDate, {
                formatStr: DateUtils.FORMATS.LLHHmm,
              })}
            </p>
          </Accordion.Control>
          <Accordion.Panel className="pt-4 pl-5">{body}</Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Card>
  );
};
